<div id="build_info_container_id" class="signOffPageContainer">
  Id : {{buildDetails.id}}
  <br> Num : {{buildDetails.num}}
  <br> Branch : {{buildDetails.branch}}
  <br> Region : {{getRegion()}}
  <br> Tag : {{buildDetails.tag}}
</div>